import { api, Response, STATUS } from "../constants/api";
import { TransactionType } from "../constants/transaction";
import { get, post } from "../utils/request";

export const getTransactionsByUserId = async (
  userId: string | null,
): Promise<Response> => {
  let errorMessage = "No user id provided";

  if (userId) {
    const res = await get(`${api.transaction}/${userId}`);
    if (res?.status === STATUS.SUCCESS) {
      return { result: res?.data, success: true };
    } else {
      errorMessage = res?.data;
    }
  }

  return { result: errorMessage, success: false };
};

export const createTransaction = async (
  payload: Omit<TransactionType, "_id"> & { userId: string | null },
): Promise<Response> => {
  const res = await post(`${api.transaction}/`, payload);
  if (res?.status === STATUS.CREATED) {
    return { result: res?.data, success: true };
  }

  return { result: res?.data, success: false };
};
